import React, { useState } from 'react';

const BreakCreationForm = () => {
  const [breakDetails, setBreakDetails] = useState('');
  const [teamSelect, setTeamSelect] = useState(false);
  const [randomTeam, setRandomTeam] = useState(false);
  const [numberOfSpots, setNumberOfSpots] = useState(1);
  const [pricePerSpot, setPricePerSpot] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [url, setUrl] = useState('');
  const [description, setDescription] = useState('');

  const handleCreateBreak = () => {
    // Implement logic to handle the creation of Break with the form data
    console.log('Creating Break with the following data:');
    console.log('Break Details:', breakDetails);
    console.log('Team Select:', teamSelect);
    console.log('Random Team:', randomTeam);
    console.log('Number of Spots:', numberOfSpots);
    console.log('Price Per Spot:', pricePerSpot);
    console.log('Selected Option:', selectedOption);
    console.log('URL:', url);
    console.log('Description:', description);
  };

  return (
    <div>
      <h2>Create Break</h2>
      <div>
        <label>
          Break Details:
          <input type="text" value={breakDetails} onChange={(e) => setBreakDetails(e.target.value)} />
        </label>
      </div>
      <div>
        <label>
          <input type="checkbox" checked={teamSelect} onChange={() => setTeamSelect(!teamSelect)} />
          Team Select
        </label>
        <label>
          <input type="checkbox" checked={randomTeam} onChange={() => setRandomTeam(!randomTeam)} />
          Random Team
        </label>
      </div>
      <div>
        <label>
          Number of Spots:
          <input type="number" value={numberOfSpots} onChange={(e) => setNumberOfSpots(e.target.value)} />
        </label>
      </div>
      <div>
        <label>
          Price Per Spot:
          <input type="number" value={pricePerSpot} onChange={(e) => setPricePerSpot(e.target.value)} />
        </label>
      </div>
      <div>
        <label>
          Options:
          <select value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
            <option value="">Select Option</option>
            <option value="Option1">Option 1</option>
            <option value="Option2">Option 2</option>
            {/* Add more predefined options */}
          </select>
        </label>
      </div>
      <div>
        <label>
          URL:
          <input type="text" value={url} onChange={(e) => setUrl(e.target.value)} />
        </label>
      </div>
      <div>
        <label>
          Description:
          <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
        </label>
      </div>
      <button onClick={handleCreateBreak}>Create Break</button>
    </div>
  );
};

export default BreakCreationForm;
